import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { Text } from '@/components/ui/Typography/Body/Text';
export const NumberBadge = (props) => {
    const { className = '', number, tagName: TagName = 'span' } = props;
    return (_jsx(TagName, Object.assign({ className: clsx('inline-flex items-center justify-center', 'px-4 h-20 min-w-[16px]', 'bg-orange-100', 'rounded-sm', className) }, { children: _jsx(Text, Object.assign({ className: '!leading-[20px]', color: 'white', fontFamily: 'alpha', isBold: true, size: 'xs', tagName: 'span' }, { children: number })) })));
};
